module.exports = __webpack_public_path__ + "img/rings-0.671de42c.gif";